import theme from "@/theme";

export const stylesLongPostHeader = {
  container: (preview: boolean, scrolled: boolean) => ({
    padding: "0 26px",
    zIndex: 1300,
    bgcolor: "white",
    height: "72px !important",
    position: "sticky",
    top: 0,
    width: "100%",
    flexShrink: 0,
    boxShadow: !preview && scrolled ? "0 4px 6px 0 #545B6114" : "none",
    margin: "0 0 10px 0",
  }),

  backButton: {
    width: 24,
    height: 24,
    position: "relative",
    top: "0px",
    padding: "3px",
  },

  arrowIcon: {
    width: 24,
    height: 24,
    opacity: 1,
  } as React.CSSProperties,

  MessageWrapper: {
    marginLeft: "166px",
    flex: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  centerText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "Medium",
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "-1%",
    color: "#C6CACE",
    padding: "2px 6px",
    borderRadius: "6px",
    marginLeft: "6px",
  },
  centerTextPreview: (preview: boolean, isEdit: boolean) => ({
    fontWeight: 500,
    fontStyle: "Medium",
    fontSize: "16px",
    letterSpacing: "-1%",
    color: "#000000",
    padding: "2px 6px",
    borderRadius: "6px",
    marginLeft: preview ? (isEdit ? "-6px" : "80px") : "135px",
    fontFamily: "Poppins",
  }),
  howToPublishButton: {
    width: 172,
    height: 40,
    borderRadius: 26,
    padding: "8px",
    gap: "4px",
    textTransform: "none",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: theme.palette.custom.mainBlue,
    whiteSpace: "nowrap",
    "& .MuiButton-startIcon": {
      margin: 0,
    },
  },
  previewButton: {
    width: 127,
    height: 40,
    borderRadius: 26,
    padding: "8px 32px",
    gap: 10,
    opacity: 1,
    textTransform: "none",
    fontFamily: "Poppins",
    transform: "rotate(0deg)",
  },
  previewButtonSave: {
    width: 139,
    height: 40,
    borderRadius: 26,
    padding: "8px 16px",
    gap: 10,
    opacity: 1,
    textTransform: "none",
    fontFamily: "Poppins",
    transform: "rotate(0deg)",
  },
  publishButton: (disabled: boolean) => ({
    textTransform: "none",
    width: 123,
    height: 40,
    borderRadius: 26,
    padding: "8px 32px",
    background: disabled ? "#8BC5F4" : theme.palette.custom.mainBlue,
    color: "#FFFFFF",
    fontFamily: "Poppins",
    "&:hover": {
      background: disabled ? "#8BC5F4" : theme.palette.custom.mainBlue,
    },

    "&.Mui-disabled": {
      background: "#8BC5F4 !important",
      color: "#FFFFFF !important",
      opacity: 1,
    },
  }),
  SaveChanges: (disabled: boolean) => ({
    textTransform: "none",
    width: 179,
    height: 40,
    borderRadius: 26,
    padding: "8px 32px",
    background: disabled ? "#8BC5F4" : theme.palette.custom.mainBlue,
    color: "#FFFFFF",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    "&:hover": {
      background: disabled ? "#8BC5F4" : theme.palette.custom.mainBlue,
    },

    "&.Mui-disabled": {
      background: "#8BC5F4 !important",
      color: "#FFFFFF !important",
      opacity: 1,
    },
  }),
  errorMessage: {
    textAlign: "center",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "-1%",
    background: "#C6CACE",
    padding: "4px 10px",
    borderRadius: "6px",
    marginTop: "12px",
  },
};
